import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ThemeVariant = 'default' | 'daltonism'

interface AppState {
  sidebarOpen: boolean
  currentPage: string
  themeVariant: ThemeVariant
}

// Load theme preference from localStorage
const loadThemePreference = (): ThemeVariant => {
  try {
    const saved = localStorage.getItem('themeVariant')
    return saved === 'daltonism' ? 'daltonism' : 'default'
  } catch {
    return 'default'
  }
}

const initialState: AppState = {
  sidebarOpen: false,
  currentPage: '/developer-map',
  themeVariant: loadThemePreference(),
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    updateCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload
    },
    setThemeVariant: (state, action: PayloadAction<ThemeVariant>) => {
      state.themeVariant = action.payload
      try {
        localStorage.setItem('themeVariant', action.payload)
      } catch {
        // Ignore localStorage errors
      }
    },
    toggleThemeVariant: (state) => {
      const newVariant: ThemeVariant =
        state.themeVariant === 'default' ? 'daltonism' : 'default'
      state.themeVariant = newVariant
      try {
        localStorage.setItem('themeVariant', newVariant)
      } catch {
        // Ignore localStorage errors
      }
    },
  },
})

export const {
  setSidebarOpen,
  toggleSidebar,
  updateCurrentPage,
  setThemeVariant,
  toggleThemeVariant,
} = appSlice.actions

export const appReducer = { app: appSlice.reducer }
